var MapType = /* @__PURE__ */ ((MapType2) => {
  MapType2["ROADMAP"] = "ROADMAP";
  MapType2["SATELITE"] = "SATELITE";
  MapType2["HYBRID"] = "HYBRID";
  MapType2["TERRAIN"] = "TERRAIN";
  MapType2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return MapType2;
})(MapType || {});
export {
  MapType
};
//# sourceMappingURL=plugin_map.enums.js.map
